/*
 * @Author: changcheng
 * @LastEditTime: 2022-11-11 16:55:44
 */
import { useSelector } from "react-redux";
import { RootState } from "@root/store/index";
import { UserDetailInfoProps } from "@root/actions/index";
import { Button, Form, Input, message } from "antd";
import { updatePassWord } from "@root/common/service";
import { validatorPassWord } from "@root/common/utils";
import "./_style.scss";
const commonInputSty = {
  width: "230px",
};
const UpdatePassWord = () => {
  const { userDetailInfo } = useSelector((state: RootState) => state.userInfo);
  const { userId } = userDetailInfo as UserDetailInfoProps;
  // 修改密码
  const updatePassWordFinish = async (values: {
    pwd: string;
    newPassword: string;
    oldPwd: string;
  }) => {
    const { pwd, newPassword, oldPwd } = values;
    if (pwd !== newPassword) {
      message.info("两次密码不一致");
      return;
    }
    if (!validatorPassWord(newPassword)) {
      message.info("密码必须由字母、数字、8-20位组成");
      return;
    }
    await updatePassWord({ userId, pwd, oldPwd });
    message.success("修改成功");
  };
  return (
    <div className="update_Password">
      <h2>修改密码</h2>
      <Form onFinish={updatePassWordFinish}>
        <Form.Item
          name="oldPwd"
          label="请输入旧密码"
          rules={[{ required: true, message: "请输入旧密码" }]}
        >
          <Input.Password
            placeholder="请输入旧密码"
            style={commonInputSty}
            autoComplete="new-password"
          />
        </Form.Item>
        <Form.Item
          name="pwd"
          label="请设置新密码"
          rules={[{ required: true, message: "请设置新密码" }]}
        >
          <Input.Password
            placeholder="请设置新密码"
            style={commonInputSty}
            autoComplete="new-password"
          />
        </Form.Item>
        <Form.Item
          name="newPassword"
          label="请确认新密码"
          rules={[{ required: true, message: "请确认新密码" }]}
        >
          <Input.Password
            placeholder="请确认新密码"
            style={commonInputSty}
            autoComplete="new-password"
          />
        </Form.Item>
        <Form.Item wrapperCol={{ offset: 12, span: 16 }}>
          <Button type="primary" htmlType="submit">
            确认
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};
export default UpdatePassWord;
